module.exports = __webpack_public_path__ + "img/pallet.c62f6972.svg";